// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"837e693c","365":"db2a566a","650":"5c2fb6b6","654":"df11d478"}[chunkId] + ".chunk.css";
};